module.exports = __webpack_public_path__ + "assets/img/404_forum.42a7f5f6.svg";